import draw_point from '../draw_point'
import * as Constants from '../../constants';

export const DrawText = { ...draw_point }

DrawText.onSetup = function (opts = {}) {
    const point = this.newFeature({
        type: Constants.geojsonTypes.FEATURE,
        properties: {
            name: '文字注记',
            'display-type': 'symbol',
            'text-size': 16,
            'text-color': '#000000',
            text: '文字注记',
            visible: true,
            description: "",
            'properties-dictionary': [
                { key: 'name', label: '名称', type: 'string' },
                { key: 'text', label: '文字内容', type: 'string', },
                { key: 'text-size', label: '文字大小', type: 'number', min: 0 },
                { key: 'text-color', label: '文字颜色', type: 'color' },
                { key: 'description', label: '说明', type: 'textArea' }
            ],
            ...opts
        },
        geometry: {
            type: Constants.geojsonTypes.POINT,
            coordinates: []
        }
    });

    this.addFeature(point);
    0
    this.clearSelectedFeatures();
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
    this.activateUIButton(Constants.types.POINT);

    this.setActionableState({
        trash: true
    });

    return { point };
};

function loadImage(map, imageId, imageUrl) {
    return new Promise((resolve) => {
        if (map.hasImage(imageId)) {
            resolve()
        } else {
            map.loadImage(imageUrl, (error, image) => {
                map.addImage(imageId, image)
                resolve()
            })
        }
    })
}

export const DrawImage = { ...draw_point }
/**
 *
 * @param {*} opts
 * @param {*} opts.imageId
 * @param {*} opts.imageUrl
 * @returns
 */
DrawImage.onSetup = function (opts) {
    const { imageId, imageUrl } = opts
    if (!imageId || !imageUrl) throw new Error('必须传入图标信息')

    const appendProperties = {}
    let appendDictionary = []
    if (opts.appendDictionary) {
        appendDictionary = opts.appendDictionary
        appendDictionary.forEach(element => {
            appendProperties[element.key] = element.default
        });
    }

    const iconSize = opts.iconSize ? opts.iconSize : 1;

    const point = this.newFeature({
        type: Constants.geojsonTypes.FEATURE,
        properties: {
            name: '符号标绘',
            'display-type': 'symbol',
            'icon-size': iconSize,
            description: "",
            'properties-dictionary': [
                { key: 'name', label: '名称', type: 'string' },
                { key: 'icon-size', label: '图标放大倍数', type: 'number', min: 0, step: 0.01 },
                { key: 'description', label: '说明', type: 'textArea' },
                ...appendDictionary
            ],
            ...appendProperties
        },
        geometry: {
            type: Constants.geojsonTypes.POINT,
            coordinates: []
        }
    });

    this.addFeature(point);

    loadImage(this.map, imageId, imageUrl).then(() => {
        point.properties['image-id'] = imageId
        point.properties['image-url'] = imageUrl
    })

    this.clearSelectedFeatures();
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
    this.activateUIButton(Constants.types.POINT);

    this.setActionableState({
        trash: true
    });
    return { point };
};


export const DrawCamera = { ...draw_point }
/**
 *
 * @param {*} opts
 * @param {*} opts.imageId
 * @param {*} opts.imageUrl
 * @returns
 */
DrawCamera.onSetup = function (opts) {
    const { imageId, imageUrl } = opts
    if (!imageId || !imageUrl) throw new Error('必须传入图标信息')

    const appendProperties = {}
    let appendDictionary = []
    if (opts.appendDictionary) {
        appendDictionary = opts.appendDictionary
        appendDictionary.forEach(element => {
            appendProperties[element.key] = element.default
        });
    }

    const iconSize = opts.iconSize ? opts.iconSize : 1;

    const point = this.newFeature({
        type: Constants.geojsonTypes.FEATURE,
        properties: {
            name: '视频点标绘',
            'display-type': 'symbol',
            'icon-size': iconSize,
            'camera-url':'',
            'properties-dictionary': [
                { key: 'name', label: '名称', type: 'string' },
                { key: 'icon-size', label: '图标放大倍数', type: 'number', min: 0, step: 0.01 },
                { key: 'camera-url', label: '视频地址', type: 'textArea' },
                ...appendDictionary
            ],
            ...appendProperties
        },
        geometry: {
            type: Constants.geojsonTypes.POINT,
            coordinates: []
        }
    });

    this.addFeature(point);

    loadImage(this.map, imageId, imageUrl).then(() => {
        point.properties['image-id'] = imageId
        point.properties['image-url'] = imageUrl
    })

    this.clearSelectedFeatures();
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
    this.activateUIButton(Constants.types.POINT);

    this.setActionableState({
        trash: true
    });
    return { point };
};